import {useMemo} from 'react';

export const useActions = ({descriptionList}) => {
  //#region [---- [HOOKS] ----]
  const descriptionClassName = useMemo(
    () =>
      descriptionList
        ? descriptionList?.length > 1
          ? 'carousel-item-description-list'
          : 'carousel-item-description'
        : '',
    [descriptionList],
  );
  //#endregion

  return {
    descriptionClassName,
  };
};
